declare namespace $ {

	type $mol_text__text_giper_balls_offer_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	export class $giper_balls_offer extends $mol_page {
		Content( ): $mol_text
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=offer.view.tree.d.ts.map